'use strict';

const scrollTop = [
  function () {
    return function (value) {
      if (angular.isNumber(value)) {
        document.documentElement.scrollTop = value;
        document.body.scrollTop = value;
      }

      return document.documentElement.scrollTop || document.body.scrollTop || 0;
    };
  }
];

export default scrollTop;



// WEBPACK FOOTER //
// ./app/src/services/scroll_top.js